import React from "react";
import PropTypes from "prop-types";

export default function ErrorComponent(props) {
  const { error, component: Component } = props;
  if (!Array.isArray(error) && error instanceof Object) {
    return <Component>{JSON.stringify(error)}</Component>;
  }
  if (Array.isArray(error)) {
    return (
      <Component>
        {error
          .map(errorItem => JSON.stringify(errorItem))
          .join(", ")
          .replace(/"/g, "")}
      </Component>
    );
  }
  if (error === null) return null;
  return <Component>{error.message || error}</Component>;
}

ErrorComponent.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.any
  ]).isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({})
  ])
};

ErrorComponent.defaultProps = {
  error: ""
};
